import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-it-report-list',
  templateUrl: './it-report-list.component.html',
  styleUrls: ['./it-report-list.component.css']
})
export class ITReportListComponent implements OnInit {

  menuList: any;
  allowedComponents = new Set<string>();
  allowedsubmenuComponents = new Set<string>();

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
      menu.menu?.menuComponents?.forEach(component => {
        this.allowedComponents.add(component.name);
      });

      menu.menu.submenus?.forEach(submenu => {
        submenu.subMenuComponents?.forEach(submenuComponent => {
          this.allowedsubmenuComponents.add(submenuComponent.name);
        });
      });
    });
   
  }

  hasAccess(componentName: string): boolean {
    return this.allowedsubmenuComponents.has(componentName);
  }

  assetPhysicalVerificationClick() {
    this.router.navigate(['dashboard/physical-verification-report']);
  }
  assetpopupconfirmationClick() {
    this.router.navigate(['dashboard/popup-confirmation-report']);
  }
  assetHistoryClick() {
    this.router.navigate(['dashboard/transfer-history-report']);
  }
}
